import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getParentEmailAddress } from "state/school_money/selectors";
import { closeCheckout } from "state/school_money/actions";
import Button from "components/Button";

import "./PaymentSuccess.css";

class PaymentSuccess extends React.Component {

  static propTypes = {
    schoolID: PropTypes.string.isRequired
  }

  render() {
    const { emailAddress } = this.props;

    return (
      <div>
        <h1 className="payment-success__heading">Payment successful!</h1>
        <div className="payment-success__body">
          <p>Thank you for your payment! Please note that there may be a slight delay in processing, but we will have it completed shortly. A receipt will be sent to {emailAddress}.</p>
        </div>
        <Button className="payment-success__close-button" onClick={this.props.close}>Done</Button>
      </div>
    )
  }
}

export default connect(
  (state, { schoolID }) => ({
    emailAddress: getParentEmailAddress(state, schoolID)
  }),
  {
    close: closeCheckout
  }
)(PaymentSuccess);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/checkout/PaymentSuccess.js